import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import TrendingSection from './components/TrendingSection';
import HowItWorksSection from './components/HowItWorksSection';
import ValueSection from './components/ValueSection';
import SeoContentSection from './components/SeoContentSection';
import ArticleGridSection from './components/ArticleGridSection';
import CommunitySection from './components/CommunitySection';
import CtaSection from './components/CtaSection';
import FaqSection from './components/FaqSection';
import { faqItems } from '@/mocks/content';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pandabuy.hair';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'PandabuySpreadsheet Hub',
  url: siteUrl,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <TrendingSection />
        <HowItWorksSection />
        <ValueSection />
        <SeoContentSection />
        <ArticleGridSection />
        <CommunitySection />
        <CtaSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}